import Router from 'next/router';
import WindowFloat from '@/frontend/components/qecomps/WindowFloat';
import { signIn,} from "next-auth/react"
import { useState } from 'react';
import Text from '@/frontend/components/qecomps/Text'
import Captcha from '@/frontend/components/qecomps/Captcha'
import { v4 as uuidv4, v4 } from 'uuid';
import SiteConfig from '@/common/SiteConfig';
import Copy from '@/frontend/components/qecomps/Copy';
import { SSRGlobal } from '../qecomps/Context';
import Img from '../qecomps/Img';
const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export default (props)=>
{
  let z = SSRGlobal()
  var [phase , setPhase] = useState(null);
  var [uuid , setUuid] = useState(v4());
  var [error , setError] = useState(null);

  var [email, setEmail] = useState("")
  var [captcha, setCaptcha] = useState("")
  var [vcode, setVcode] = useState("")
  var [show, setShow] = useState(!props.ctrl);
  if(props.ctrl)
  {
    props.ctrl.show = ()=>{
      setShow(true)
    }
    props.ctrl.hide = ()=>{
      setShow(false)
    }
  }

let validemail = validateEmail(email)


return show?<WindowFloat title={z.lang.suspention} maxWidth="320px" z={250} darkness={0.9}>

  <c-cc style={{fontSize:12, height:70}}>
    <span>{z.lang.suspenddetail}</span>
    <br-xx/>
    <span>{z.lang.suspendmore}</span>
    <br-xx/>
    <span>
      <a href={"mailto:"+SiteConfig.email}>{SiteConfig.email}</a>
      <sp-2/>
      <Img src={global.cdn("/files/copy.svg")} style={{display:"inline-block", verticalAlign:"middle", width:15, cursor:"pointer"}} 
      on={()=>{Copy(SiteConfig.email); alerter(z.lang.copied)}}/>
    </span>
    <br-x/>

  </c-cc>
</WindowFloat>:null

}